var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "pt-5 pb-5 is-max-desktop",
      attrs: { id: "evaluations-panel" },
    },
    [
      _c("EvaluationBreadcrumb", { attrs: { links: _vm.links } }),
      !_vm.isLoadingEvaluation
        ? _c(
            "div",
            [
              _c("EvaluationHeader", { attrs: { debtor: _vm.debtor } }),
              _c(
                "div",
                { staticClass: "box", attrs: { id: "evaluations-details" } },
                [
                  _c("b-button", {
                    staticClass: "mb-2 is-pulled-right",
                    attrs: {
                      disabled: !_vm.isUserAllowed(),
                      tag: "router-link",
                      "data-cy": "new-evaluation",
                      to: {
                        name: "evaluation-process",
                        params: {
                          evaluationId: _vm.$route.params.evaluationId,
                        },
                      },
                      type: "is-secondary",
                      label: "Nueva evaluación",
                    },
                  }),
                  _c("div", { staticClass: "is-clearfix" }),
                  _c("EvaluationTable", {
                    attrs: { "id-number": _vm.debtor.idNumber },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.isLoadingEvaluation ? _c("Spinner") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }